"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Banner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../constants");
var _BannerMixin = require("../../mixins/components/BannerMixin");
var _statusIconAppearance = require("../../util/statusIconAppearance");
var _Toast = require("../Toast/Toast");
var _excluded = ["onClose", "isOpen"];
/**
 * @extends Toast
 * @since 7.13.0
 */
var Banner = /*#__PURE__*/(0, _styledComponents.default)(function (props) {
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    openState = _useState2[0],
    setOpenState = _useState2[1];
  if (
  // Controlled closed
  typeof props.isOpen === 'boolean' && !props.isOpen ||
  // Uncontrolled closed
  typeof props.isOpen !== 'boolean' && !openState) {
    return null;
  }
  var customOnClose = function customOnClose() {
    setOpenState(false);
    if (props.onClose) {
      props.onClose();
    }
  };

  // Prevent default isOpen value bleed to Toast
  var onClose = props.onClose,
    isOpen = props.isOpen,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Toast.Toast, (0, _extends2.default)({
    onClose: customOnClose
  }, rest));
}).withConfig({
  displayName: "Banner",
  componentId: "c11n-8-107-0__sc-tm5jty-0"
})(["", ""], _BannerMixin.BannerMixin);
exports.Banner = Banner;
Banner.displayName = 'Banner';
Banner.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * An optional action button.
   *
   * @ignoreInControls
   */
  actionButton: _propTypes.default.node,
  /**
   * The type of banner to display.
   *
   * Note: The `appearance` value can modify component content such as `icon`.
   */
  appearance: _propTypes.default.oneOf(Object.values(_constants.STATUS_TYPES)),
  /**
   * The body content of the banner message.
   */
  body: _propTypes.default.node,
  /**
   * In general, you will want to use the `body` prop,
   * but you can use the children prop to override the default component layout.
   * When passing a function, the function will receive all the component props as the only
   * argument (Note: some of the props may have been modified and/or enhanced,
   * so you should always use the values that are passed to the render function).
   *
   * @ignoreInControls
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * The close button node. You can set this to `<CloseButton />` if needed.
   * NOTE: Don’t make a banner dismissible if there’s an action presented
   * to the user that can help resolve the banner.
   *
   * @ignoreInControls
   */
  closeButton: _propTypes.default.node,
  /**
   * The icon node. By default, this will use an icon based on the banner `appearance`.
   *
   * @ignoreInControls
   */
  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * A Banner is uncontrolled by default.
   * You can specify `isOpen` to manually control the visibility of the component.
   *
   * @ignoreInControls
   */
  isOpen: _propTypes.default.bool,
  /**
   * Function called with the `closeButton` is clicked.
   *
   * @ignoreInControls
   */
  onClose: _propTypes.default.func,
  /**
   * Banners should have a role of [status](https://www.w3.org/TR/wai-aria-1.1/#status) or
   * [alert](https://www.w3.org/TR/wai-aria-1.1/#alert) to signal assistive technologies
   * that it requires the user's attention. In general, you will always want to use the less
   * strict "status" role.
   */
  role: _propTypes.default.oneOf(['status', 'alert'])
} : {};
Banner.defaultProps = {
  appearance: 'info',
  closeButton: null,
  icon: _statusIconAppearance.statusIconAppearance,
  isOpen: null
};

/** @component */